import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import {
  Box, Button, TextField, Typography,
  Paper, Alert, CircularProgress
} from "@mui/material";
import SecurityIcon from "@mui/icons-material/Security";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onLogin();
    } catch (err) {
      setError("Invalid email or password. Please try again.");
    }
    setLoading(false);
  };

  return (
    <Box sx={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #1a237e 0%, #0d47a1 50%, #01579b 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <Paper elevation={10} sx={{
        p: 5, width: 400, borderRadius: 3,
        display: "flex", flexDirection: "column", alignItems: "center", gap: 2
      }}>
        {/* Logo */}
        <Box sx={{
          bgcolor: "#1a237e", borderRadius: "50%",
          width: 70, height: 70,
          display: "flex", alignItems: "center", justifyContent: "center"
        }}>
          <SecurityIcon sx={{ color: "white", fontSize: 40 }} />
        </Box>

        <Typography variant="h5" fontWeight="bold" color="#1a237e">
          HQ Scan Security
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Sign in to your account
        </Typography>

        {error && <Alert severity="error" sx={{ width: "100%" }}>{error}</Alert>}

        <Box component="form" onSubmit={handleLogin} sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Email Address"
            type="email"
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled={loading}
            sx={{ bgcolor: "#1a237e", py: 1.5, mt: 1 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Sign In"}
          </Button>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
          HQ Scan Security Management System © 2025
        </Typography>
      </Paper>
    </Box>
  );
}